/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchRepositoryPathParams = NonNullable<operations['patchRepository']['parameters']['path']>;

export type PatchRepositoryRequestBody = OperationRequestBodyContent<operations['patchRepository']>;

export interface Input extends PatchRepositoryPathParams {
  apiVersion?: string;
  body: PatchRepositoryRequestBody;
}

export async function patchRepository(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/code-refs/repositories/{repo}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
